/**
 * Membership / Subscription config (Growth Platform — Strategy #01: VIP).
 *
 * Configurable membership plans + benefits (spec §2: "Membership names, prices,
 * benefits, and eligibility rules must be configurable. Do not hard-code
 * business rules throughout the UI").
 *
 * The UI reads plans from here — never hard-codes price/benefit strings — so
 * the same records can later be served from the MERN /api/memberships endpoint
 * and drive real (Stripe) billing without UI changes.
 *
 * NOTE: `billingEnabled: false` is the honest feature flag — real recurring
 * payment is NOT wired yet. The Join CTA captures a waitlist lead until the
 * backend + payment provider are live (spec rules 8–11, §2 "Prepare for
 * recurring payment integration").
 */

export const MEMBERSHIP_CONFIG = {
  billingEnabled: false, // flip to true only when Stripe (or equivalent) is live
  program: {
    id: "vip-plus",
    name: "VIP+",
    tagline: "Instead of only paying for repairs — join the club that pays you back.",
  },
  plans: [
    {
      id: "vip-plus-monthly",
      label: "Monthly",
      price: 7.99,
      interval: "month",
      priceSuffix: "/mo",
      note: "Cancel anytime",
      highlighted: false,
    },
    {
      id: "vip-plus-yearly",
      label: "Yearly",
      price: 79,
      interval: "year",
      priceSuffix: "/yr",
      note: "Best value — save ~$16 vs monthly",
      highlighted: true,
      badge: "Most Popular",
    },
  ],
  // Benefits straight from the growth guide (Strategy #01).
  benefits: [
    { icon: "fas fa-percent", text: "15% off all accessories" },
    { icon: "fas fa-shield-alt", text: "Free screen protector installation" },
    { icon: "fas fa-broom", text: "Free phone cleaning every month" },
    { icon: "fas fa-plug", text: "Free charging port cleaning" },
    { icon: "fas fa-bolt", text: "Priority repair service" },
    { icon: "fas fa-tools", text: "10% off repairs" },
    { icon: "fas fa-gift", text: "Birthday coupon" },
    { icon: "fas fa-fire", text: "Members-only flash sales" },
    { icon: "fas fa-star", text: "Early access to new products" },
  ],
  terms:
    "VIP+ benefits apply in-store at Cell Station, Willow Grove PA. Membership is billed per the selected plan once activated. Cannot be combined with certain other offers. Full terms provided at signup.",
};
